module.exports = __webpack_public_path__ + "assets/a-shu4.85576cbc.svg";